<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loadingRoles" />
      <b-card-title>أدوار المستخدم</b-card-title>
      <b-input-group dir="rtl" class="input-group-merge mb-1 w-50">
        <b-form-input
          v-model="searchKey"
          placeholder="أدخل اسم الدور أو جزء منه ..."
        />
        <b-input-group-append is-text>
          <feather-icon
            v-if="searchKey.length > 0"
            class="cursor-pointer"
            @click="searchKey = ''"
            icon="XIcon"
            size="17"
          />
          <feather-icon size="17" v-else icon="SearchIcon" />
        </b-input-group-append>
      </b-input-group>
      <b-list-group>
        <b-list-group-item
          class="d-flex cursor-pointer justify-content-between align-items-center"
          v-for="role in filteredRoles"
          :key="role.id"
          @click.self="
            onChangeRole({ hasRole: role.selected, roleId: role.id })
          "
        >
          <router-link
            class="role-link"
            :to="
              $route.path.includes('ministry-user')
                ? `/ministry/update-role/MIN/${role.id}`
                : `/ministry/update-role/NGO/${role.id}`
            "
            >{{ role.name }}</router-link
          >

          <feather-icon
            v-if="role.selected"
            icon="CheckSquareIcon"
            class="text-success"
            size="20"
            @click.self="
              onChangeRole({ hasRole: role.selected, roleId: role.id })
            "
          />
          <feather-icon
            v-else
            icon="XSquareIcon"
            class="text-secondary"
            size="20"
            @click.self="
              onChangeRole({ hasRole: role.selected, roleId: role.id })
            "
          />
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import debounce from "lodash.debounce";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BCard,
  BListGroup,
  BListGroupItem,
  BFormCheckboxGroup,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BFormCheckbox,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
} from "bootstrap-vue";

import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BFormCheckboxGroup,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BFormCheckbox,
    LoadingOverlay,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
  },
  data() {
    return {
      roles: [],
      filteredRoles: [],
      searchKey: "",
    };
  },
  methods: {
    ...mapActions("Ministry/Settings/Users", ["fetchUserRoles", "changeRole"]),
    onChangeRole({ hasRole, roleId }) {
      if (hasRole) {
        this.$bvModal
          .msgBoxConfirm(
            "هل أنت متأكد من إزالة الدور من المستخدم ؟\nتنويه : سيتم تسجيل خروج المستخدم من جميع جلساته .",
            {
              title: "تأكيد إزالة الدور",
              size: "sm",
              okVariant: "danger",
              okTitle: "تأكيد",
              cancelTitle: "إلغاء",
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then((value) => {
            if (value)
              this.changeRole({
                id: this.$route.params.id,
                isMinistry: this.$route.path.includes("ministry-user"),
                roleId,
              }).then(() => {
                this.fetchRoles();
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تمت إزالة الدور من المستخدم بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                  },
                });
              });
          });
      } else {
        this.$bvModal
          .msgBoxConfirm(
            "هل أنت متأكد من منح الدور للمستخدم ؟\nتنويه : سيتم تسجيل خروج المستخدم من جميع جلساته .",
            {
              title: "تأكيد منح الدور",
              size: "sm",
              okVariant: "success",
              okTitle: "تأكيد",
              cancelTitle: "إلغاء",
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then((value) => {
            if (value)
              this.changeRole({
                id: this.$route.params.id,
                isMinistry: this.$route.path.includes("ministry-user"),
                roleId,
              }).then(() => {
                this.fetchRoles();
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تم منح الدور للمستخدم بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                  },
                });
              });
          });
      }
    },
    fetchRoles() {
      this.fetchUserRoles({
        id: this.$route.params.id,
        isMinistry: this.$route.path.includes("ministry-user"),
      }).then((res) => {
        this.roles = res.data.data;
        this.filteredRoles = res.data.data;
      });
    },
  },
  computed: {
    ...mapGetters("Ministry/Settings/Users", ["loadingRoles"]),
  },
  watch: {
    searchKey: debounce(function (value) {
      this.filteredRoles = this.roles.filter((el) => el.name.includes(value));
    }, 300),
  },

  created() {
    this.fetchRoles();
  },
};
</script>

<style>
.role-link:hover {
  text-decoration: underline !important;
}
</style>
